export default __webpack_public_path__ + "static/media/logo-app.ad92f1ae.webp";